import { render } from "./TestimonialCardComponent.vue?vue&type=template&id=9a0cbd26"
import script from "./TestimonialCardComponent.vue?vue&type=script&lang=js"
export * from "./TestimonialCardComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__